/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  MemoryStore,
  MemoryStore$inboundSchema,
  MemoryStore$Outbound,
  MemoryStore$outboundSchema,
} from "./memorystore.js";

export type MemoryStoreList = {
  object: "list";
  data: Array<MemoryStore>;
  firstId: string | null;
  lastId: string | null;
  hasMore: boolean;
};

/** @internal */
export const MemoryStoreList$inboundSchema: z.ZodType<
  MemoryStoreList,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(MemoryStore$inboundSchema),
  first_id: z.nullable(z.string()),
  last_id: z.nullable(z.string()),
  has_more: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    "first_id": "firstId",
    "last_id": "lastId",
    "has_more": "hasMore",
  });
});
/** @internal */
export type MemoryStoreList$Outbound = {
  object: "list";
  data: Array<MemoryStore$Outbound>;
  first_id: string | null;
  last_id: string | null;
  has_more: boolean;
};

/** @internal */
export const MemoryStoreList$outboundSchema: z.ZodType<
  MemoryStoreList$Outbound,
  z.ZodTypeDef,
  MemoryStoreList
> = z.object({
  object: z.literal("list"),
  data: z.array(MemoryStore$outboundSchema),
  firstId: z.nullable(z.string()),
  lastId: z.nullable(z.string()),
  hasMore: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    firstId: "first_id",
    lastId: "last_id",
    hasMore: "has_more",
  });
});

export function memoryStoreListToJSON(
  memoryStoreList: MemoryStoreList,
): string {
  return JSON.stringify(MemoryStoreList$outboundSchema.parse(memoryStoreList));
}
export function memoryStoreListFromJSON(
  jsonString: string,
): SafeParseResult<MemoryStoreList, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MemoryStoreList$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MemoryStoreList' from JSON`,
  );
}
